export default [
  {
    path: '/jianianhua',
    name: 'jianianhuaindex',
    meta: {
      title: '嘉年华',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/index'], resolve)
    }
  },
  {
    path: '/jianianhua/rule',
    name: 'jianianhuarule',
    meta: {
      title: '活动规则',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/rule'], resolve)
    }
  },
  {
    path: '/jianianhua/detaillist',
    name: 'jianianhuadetaillist',
    meta: {
      title: '明细',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/detaillist'], resolve)
    }
  },
  {
    path: '/jianianhua/scratch',
    name: 'jianianhuascratch',
    meta: {
      title: '刮刮乐',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/scratch'], resolve)
    }
  },
  {
    path: '/jianianhua/stamp',
    name: 'jianianhuastamp',
    meta: {
      title: '邮票抢兑',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/stamp'], resolve)
    }
  },
  {
    path: '/jianianhua/mine',
    name: 'jianianhuamine',
    meta: {
      title: '我的抢兑',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/myexchange'], resolve)
    }
  },
  {
    path: '/jianianhua/confirm/:productid',
    name: 'jianianhuaconfirm',
    meta: {
      title: '确认订单',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/confirm'], resolve)
    }
  },
  {
    path: '/jianianhua/stampdetail/:id',
    name: 'jianianhuastampdetail',
    meta: {
      title: '我的抢兑',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/stampdetail'], resolve)
    }
  },
  {
    path: '/jianianhua/logistic/:id',
    name: 'jianianhualogistics',
    meta: {
      title: '物流信息',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/logistics'], resolve)
    }
  },
  {
    path: '/jianianhua/detail/:id',
    name: 'jianianhuadetail',
    meta: {
      title: '商品详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/pro_detail'], resolve)
    }
  },
  {
    path: '/jianianhua/address',
    name: 'jianianhuaAddress',
    meta: {
      title: '地址填写',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/jianianhua/address'], resolve)
    }
  }
]
